import React, { useEffect, useState, useRef } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardHeaderIcon,
  CardHeaderToolbar,
  ModalProgressBar,
} from '../../../../../_metronic/_partials/controls';
import ChangedInfo from '../../../../components/ChangedInfo';
import Activities from '../../../../components/Activities';
import * as actions from '../../_redux/deliveries/deliveriesActions';
import { initialDeliver } from '../DeliveriesUIHelpers';
import DeliverMain from './Deliver/DeliverMain';

export function DeliverViewDialog({
  history,
  match: {
    params: { id },
  },
}) {
  const intl = useIntl();
  const [tab, setTab] = useState('deliver');
  const [title, setTitle] = useState('');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [dialogError, setDialogError] = useState('');
  const titleText = intl.formatMessage({ id: 'DELIVERIES.TITLE.DETAIL' });
  /*const refShipping = useRef();
  const [shippingResult, setShippingResult] = useState({
    boxes: [],
    items: [],
  });*/
  //console.log('id=', id);

  const { actionsLoading, deliverForView, error, msg } = useSelector(
    (state) => ({
      actionsLoading: state.deliveries.actionsLoading,
      deliverForView: state.deliveries.deliverForView,
      error: state.deliveries.error,
      msg: state.deliveries.msg,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchDeliver(id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = intl.formatMessage({ id: 'DELIVERIES.QUICKACTIONS.TITLE' });
    console.log('deliverForView', deliverForView);
    if (deliverForView && id) {
      _title = `${titleText}: #${deliverForView.id}`;
    }

    setTitle(_title);
  }, [deliverForView, id]);

  useEffect(() => {
    setDialogError(error);
  }, [error]);

  const onHide = () => {
    history.push(`/deliveries`);
  };

  const saveDeliver = (values) => {
    if (!loading) {
      setLoading(true);
      console.log('saveDeliver', values, deliverForView);
      if (!deliverForView) {
        dispatch(actions.createDeliver(values));
      } else {
        dispatch(actions.updateDeliver(values));
      }
      setLoading(false);
    }
  };
  const btnRefSave = useRef();
  const saveDeliverClick = () => {
    //console.log('saveDeliverClick');
    if (btnRefSave && btnRefSave.current) {
      btnRefSave.current.click();
    }
  };

  const btnRefCancel = useRef();
  const cancelDeliverClick = () => {
    //console.log('saveDeliverClick');
    if (btnRefCancel && btnRefCancel.current) {
      btnRefCancel.current.click();
    }
  };

  return (
    <>
      <Modal.Body className='overlay overlay-block cursor-default'>
        {actionsLoading && <ModalProgressBar />}
        {actionsLoading && (
          <div className='overlay-layer bg-transparent'>
            <div className='spinner spinner-lg spinner-success' />
          </div>
        )}
        <Card>
          <CardHeader title={`${title}`}>
            <CardHeaderToolbar>
              <> </>
              <button
                type='button'
                onClick={cancelDeliverClick}
                className='btn btn-light btn-elevate'
              >
                <FormattedMessage id='GENERAL.BUTTON.CANCEL' />
              </button>
              <> </>
              {tab === 'deliver' && (
                <button
                  type='submit'
                  className='btn btn-primary ml-2'
                  onClick={saveDeliverClick}
                >
                  <FormattedMessage id='GENERAL.BUTTON.SAVE' />
                  {loading && (
                    <span
                      id='deliveriesaveLoading2'
                      className='ml-3 spinner spinner-white '
                    ></span>
                  )}
                </button>
              )}
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            <ul className='nav nav-tabs nav-tabs-line ' role='tablist'>
              <li className='nav-item' onClick={() => setTab('deliver')}>
                <a
                  className={`nav-link ${tab === 'deliver' && 'active'}`}
                  data-toggle='tab'
                  role='tab'
                  aria-selected={(tab === 'deliver').toString()}
                >
                  Бүртгэл
                </a>
              </li>
              <li className='nav-item' onClick={() => setTab('activity')}>
                <a
                  className={`nav-link ${tab === 'activity' && 'active'}`}
                  data-toggle='tab'
                  role='button'
                  aria-selected={(tab === 'activity').toString()}
                >
                  Өөрчлөлтийн түүх
                </a>
              </li>
            </ul>
            <div className='mt-5'>
              {tab === 'deliver' && (
                <>
                  <div className='form-group row'>
                    <div className='col-12'>
                      <DeliverMain
                        actionsLoading={actionsLoading}
                        deliverForView={deliverForView || initialDeliver}
                        initialDeliver={initialDeliver}
                        btnRefSave={btnRefSave}
                        saveDeliver={saveDeliver}
                        btnRefCancel={btnRefCancel}
                        onHide={onHide}
                        dialogError={dialogError}
                        msg={msg}
                      />
                    </div>
                  </div>
                </>
              )}
              {tab === 'activity' && id && (
                <Activities deliverCode={deliverForView.id} />
              )}
            </div>
          </CardBody>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        {deliverForView && (
          <ChangedInfo
            value={{
              createdByName: deliverForView.createdByName,
              createdAt: deliverForView.createdAt,
              updatedByName: deliverForView.createdByName,
              updatedAt: deliverForView.updatedAt,
            }}
          />
        )}
      </Modal.Footer>
    </>
  );
}
